
export const ActivitiesCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-teedee-blue via-bobo-green to-brand-purple text-white">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold mb-6">
          Ready for More Learning Adventures?
        </h2>
        <p className="text-lg mb-8 opacity-90">
          Watch Bobo & Teedee® episodes to inspire even more creative activities and learning opportunities!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="/episodes" 
            className="bg-white text-teedee-blue hover:bg-white/90 px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 inline-block"
          >
            Watch Episodes
          </a>
          <a 
            href="/about" 
            className="border-2 border-white text-white hover:bg-white hover:text-teedee-blue px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 inline-block"
          >
            Meet the Characters
          </a>
        </div>
      </div>
    </section>
  );
};
